import dayjs from 'dayjs'

export function formatDateLong(value) {
  return dayjs(value).format('MMMM D, YYYY')
}

export function formatDateSlash(value) {
  return dayjs(value).format('M/D/YY')
}

export function formatDateTimeShort(value) {
  return dayjs(value).format("MMM D [']YY [at] h:mm a")
}
